export default __webpack_public_path__ + "static/media/muskmelon.1b9d12d4.png";